var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKeyS(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33337 1H6.35569V1.44446H3.33337V1Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.88892 1.88879V1.44434H3.33337V1.88879H2.88892Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.44446 2.33313V1.88867H2.88892V2.33313H2.44446Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.44446 4.64419H2V2.33301H2.44446V4.64419Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.88892 5.08997H2.44446V4.64551H2.88892V5.08997Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33337 5.53333H2.88892V5.08887H3.33337V5.53333Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.1334 7.22312H3.68894V5.97864H3.33337V5.53418H4.1334V7.22312Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.13342 7.66614V7.22168H4.57788V7.66614H4.13342Z",
    fill: "currentColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M4.13336 8.55591H3.6889V7.66699H4.13336V8.55591Z",
    fill: "currentColor"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M5.55569 8.55566H4.13342V9.00012H5.55569V8.55566Z",
    fill: "currentColor"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M5.55566 8.55566H6.00012V5.97781H6.35569V5.53335H6.80015V5.08889H7.2446V4.64443H7.68906V2.33325H7.2446V1.88879H6.80015V1.44434H6.35569V1.88879H6.80015V2.33325H7.2446V4.64443H6.80015V5.08889H6.35569V5.53335H5.55566V8.55566Z",
    fill: "currentColor"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M5.28901 2.59961H4.40009V2.95518H4.04453V3.84409H4.40009V4.19966H5.28901V3.84409H5.64457V2.95518H5.28901V2.59961Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyS);
export default __webpack_public_path__ + "static/media/key-s.a4ed581186555390b5437853030281e1.svg";
export { ForwardRef as ReactComponent };